import React from 'react';
import ImageGallery from 'react-image-gallery';
import { Translate } from '../../i18n/LanguageProvider';

const FeatureSection = ({
	images = [],
	contentTranslationKey,
	hasHeroImage,
	icon: Icon,
	footerItems = null,
}) => (
	<div className={`feature${hasHeroImage ? '' : ' no-hero'}`}>
		<section className='container'>
			<div className='tile is-ancestor'>
				<div className='tile is-vertical is-12'>
					<div className='tile'>
						<div
							className={`tile is-${
								images.length > 0 ? '6' : '12'
							} is-full-tablet is-parent is-vertical`}
						>
							<article className='tile is-child notification is-primary content'>
								{Icon && <Icon className='icon icon--is-right' />}
								<Translate>{contentTranslationKey}</Translate>
							</article>
							{footerItems && footerItems}
						</div>
						{images.length > 0 && (
							<div className='tile is-6 is-parent'>
								<article className='tile is-child'>
									<ImageGallery items={images} showPlayButton={false} />
								</article>
							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	</div>
);

export default FeatureSection;
